import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
Axios.defaults.baseURL = API_URL;

export class HttpService {
  _axios = Axios.create();

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url, params={}) => await this.request(this.getOptionsConfig("get", url, null, params)).then(response => response).catch(error => error);

  post = async (url, data) => await this.request(this.getOptionsConfig("post", url, data)).then(response => response).catch(error => error);

  put = async (url, data) => await this.request(this.getOptionsConfig("put", url, data)).then(response => response).catch(error => error);

  patch = async (url, data) => await this.request(this.getOptionsConfig("patch", url, data)).then(response => response).catch(error => error);

  delete = async (url) => await this.request(this.getOptionsConfig("delete", url)).then(response => response).catch(error => error);

  getOptionsConfig = (method, url, data, params={}) => {
    return { method, url, data, params, headers: { 'Content-Type': 'application/vnd.api+json' } };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => reject(ex.response.data));
    });
  }
}

export default new HttpService();
